import { ObservableArray, View } from "binder"
import { ToolTypeManipulationViewModel, ToolType } from "./toolTypeManipulation-viewModel"
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class ToolTypeManipulationView extends View<ToolTypeManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-656838F4-99B6-452C-BD68-F458269DC1C6"
    }
    loadHtml(): string {
        let element = require('./toolTypeManipulation.html').default;
        let style = require('./toolTypeManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set toolTypes(v: ToolType) { this._toolTypes = v; } public get toolTypes(): ToolType { return this._toolTypes; } private _toolTypes: ToolType;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;

    addNew() {
        this.dataContext.addNew();
    }
}
